// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2008":"9dcd38f8","5531":"9dcd38f8","5877":"e4b3ef19"}[chunkId] + ".chunk.css";
};